import { format } from 'date-fns/format'
import { formatDistanceToNow } from 'date-fns/formatDistanceToNow'
import { useTranslation } from 'react-i18next'

import { DATE_FORMAT } from '@root/shared'
import { useDateFnsLocale } from '@root/shared/localization'

import { TwoRowsTextCell } from './two-rows-text-cell'

export const DateCell = (props: { date: Date; gap?: number }) => {
  const { t } = useTranslation()
  const locale = useDateFnsLocale()
  const time = formatDistanceToNow(props.date, { locale })
  const timeAgo = t('common.ago', { time })

  return (
    <TwoRowsTextCell
      gap={props.gap}
      firstRow={[
        format(props.date, DATE_FORMAT.HH_mm),
        format(props.date, DATE_FORMAT.dd_MM_yy),
      ].join(' ')}
      secondRow={timeAgo}
    />
  )
}
